import { useAsyncData, useNuxtApp } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchAccessoryExclusions() {
  const nuxtApp = useNuxtApp()
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    () => `pp-accessory-exclusions-${productId}`,
    async () =>
      await $httpFetch(
        '/product-page/products/:productId/accessory-exclusions',
        {
          pathParams: { productId },
        },
      ),
    {
      ...getOptionalEndpointTimeoutOptions(),
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
